<template>
<svg viewBox="0 0 48 48" :fill="useCurrentColor ? 'currentColor' : 'currentColor'" :class="[`${prefix}-icon`, `${prefix}-icon-microphone`]" width="1em" height="1em" v-bind="$attrs"><path fill-rule="evenodd" clip-rule="evenodd" d="M32.88 4C39.575 4 45 9.426 45 16.12c0 6.065-4.456 11.09-10.273 11.978L11.803 44.045a2 2 0 01-2.557-.228l-4.063-4.063a2 2 0 01-.228-2.556l15.947-22.925C21.79 8.456 26.815 4 32.88 4zM21.548 20.42L9.246 38.105l1.65 1.65L28.58 27.453a12.157 12.157 0 01-7.032-7.032zm4.355-8.376l-.111.198a8.08 8.08 0 0011.197 10.836c-2.422-1.13-4.954-2.93-6.545-4.52-1.612-1.613-3.417-4.122-4.541-6.514zM32.88 8.04c-1.4 0-2.718.356-3.867.983.61 1.906 2.712 5.104 4.285 6.678 1.548 1.547 4.69 3.602 6.695 4.252A8.08 8.08 0 0032.881 8.04z"/></svg>
</template>
<script>

export default {
  name: 'IconMicrophone',
  props: {
    prefix: {
        type: String,
        default: 'm',
    },
    useCurrentColor: {
        type: Boolean,
        default: false,
    },
  },
};
</script>
